import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="46" height="29" viewBox="0 0 46 29" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M34.0764 10.3799C31.8266 6.93852 28.4757 3.80247 24.1589 1.63345C23.2029 1.15307 22.0071 1.15311 21.0511 1.63354C16.7346 3.8027 13.3837 6.9386 11.1338 10.3799"
      stroke="#F0F0F0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22.605 2.42578V26.2927" stroke="#F0F0F0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1.14282 19.2224V21.9668C1.14282 23.4224 1.83856 24.8183 3.07701 25.8476C4.31547 26.8767 5.99514 27.455 7.74655 27.455H37.4635C39.215 27.455 40.8945 26.8767 42.133 25.8476C43.3713 24.8183 44.0671 23.4224 44.0671 21.9668V19.2224"
      stroke="#F0F0F0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const UploadIcon = memo(ForwardRef);
export default UploadIcon;
